var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * @description 将一个支持callback的函数转换成支持promise的
 * @param {Function} fn - 支持callback的函数
 * @param {Object} context - 执行环境
 * @returns {Function}
 */
export function promisefy(fn, context) {
    return function (...args) {
        return new Promise((resolve, reject) => {
            const cb = (err, payload) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(payload);
                }
            };
            fn.apply(context, [...args, cb]);
        });
    };
}
/**
 * @description 获取链接参数的值
 * @param {String} url - 链接地址
 * @param {String} name - 参数名称
 * @returns {String} - 参数值
 */
export function getQueryString(url, name) {
    if (!url || !name)
        return;
    return url.match(new RegExp(`(^${name}|[?|&]${name})=([^&#]+)`))
        ? RegExp.$2
        : '';
}
/**
 * @description 数字格式化容量大小
 * @param {Number} bytes 字节数
 * @param {Number} point 小数点保留的位置
 */
export function bytesToSize(bytes, point = 1) {
    if (Number(bytes) <= 0) {
        return '0 B';
    }
    const k = 1024; // or 1024
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const val = bytes / Math.pow(k, i);
    let size = val.toPrecision(3);
    size = val.toFixed(point);
    return size + sizes[i];
}
/**
 * @description 数字格式化容量大小
 * @param {any} size 字节数
 */
export function formatSize(size) {
    size = parseInt(size);
    if (!size) {
        return 0;
    }
    const sizeMap = ['B', 'KB', 'M', 'G', 'T'];
    let index = 0;
    while (size > 1024) {
        size = size / 1024;
        index++;
    }
    size = String(size.toFixed(1));
    if (/(.0)/.test(size))
        size = size.split('.0')[0];
    return `${size}${sizeMap[index]}`;
}
/**
 * @description promise方式的等待定时器
 * @param {number} millisecond 持续时间 ms
 * @returns {Promise<void>} 返回promise
 */
export function sleep(millisecond) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(null);
        }, millisecond);
    });
}
/**
 * @description 判断是否为有效的可下载链接
 * @param {string} url
 */
export function checkValidLink(url) {
    return /^(thunder|magnet|http[s]?|ftp|ed2k):/i.test(url);
}
/**
 * @description 判断是否为json字符串
 * @param {string} str
 */
export function checkIsJSON(str) {
    if (typeof str === 'string') {
        try {
            const obj = JSON.parse(str);
            if (typeof obj === 'object' && obj) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    return false;
}
/**
 * @description 转传参数序列化为链接
 * @param {string} url
 * @param {Objject} params
 */
export function joinParams(url, params) {
    if (!/\?/.test(url)) {
        url += '?';
    }
    const keyValues = Object.keys(params || {}).map((key) => {
        return `${key}=${escape(params[key])}`;
    });
    return url + keyValues.join('&');
}
/**
 * @description 从秒转成分、钟时间
 * @param {number} ms
 */
export function msToTime(ms) {
    if (ms <= 60)
        return '1分钟';
    else if (ms <= 60 * 60)
        return Math.ceil(ms / 60) + '分钟';
    else if (ms <= 60 * 60 * 24)
        return Math.ceil(ms / 3600) + '小时';
    else
        return Math.ceil(ms / (60 * 60 * 24)) + '天';
}
/**
 * @description 判断时间戳是否是今天
 * @param {any} someDate
 */
export function isToday(someDate) {
    someDate = new Date(someDate);
    const today = new Date();
    return (someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear());
}
/**
 * @description 使用async-await方式，拒绝循环的try-catch
 * @param {Promise<any>} handler
 */
export function promiseHandler(handler) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return [yield handler, null];
        }
        catch (error) {
            return [null, error];
        }
    });
}
/**
 * @description 判断移动平台（微信、QQ、微博、QQ空间、UC浏览器）
 */
export function platform(ua = window.navigator.userAgent) {
    let platform;
    if (/MicroMessenger/.test(ua)) {
        platform = 'wx';
    }
    else if (/QQ\//.test(ua)) {
        platform = 'qq';
    }
    else if (/\bWeibo|__weibo__\d/.test(ua)) {
        platform = 'weibo';
    }
    else if (/Qzone\//.test(ua)) {
        platform = 'qzone';
    }
    else if (/UCBrowser/.test(ua)) {
        platform = 'uc';
    }
    else {
        platform = 'other';
    }
    return platform;
}
/**
 *@param 创建下载文件
 * @param {any} blob  ：返回数据的blob对象或链接
 * @param {string} tagFileName  ：下载后文件名标记
 * @param {string} fileType  ：文件类 word(docx) excel(xlsx) ppt等
 */
export function downloadFile(blob, tagFileName, fileType) {
    let downloadElement = document.createElement('a');
    let href = blob;
    if (typeof blob == 'string') {
        downloadElement.target = '_blank';
    }
    else {
        href = window.URL.createObjectURL(blob);
    }
    downloadElement.href = href;
    downloadElement.download = tagFileName + '.' + fileType;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href);
    }
}
/**
 * @description 通过 A 标签打开链接
 * @param {string} uri - 需要打开的地址
 */
export function evokeByTagA(uri, isClean = true, target = '_self') {
    const tagA = document.createElement('a');
    tagA.setAttribute('href', uri);
    tagA.setAttribute('target', target); // 在未安装ios手雷时scheme会有问题
    tagA.style.display = 'none';
    // append 在 android 6 系统中有兼容性问题
    // eslint-disable-next-line unicorn/prefer-node-append
    document.body.appendChild(tagA);
    tagA.click();
    isClean && document.body.removeChild(tagA);
}
export function callIOS(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { type = 'universalLink', target, action, params, from, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        const queryParams = Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        let href = '';
        const path = `xunlei://${target}/${action}?${queryParams}`;
        if (type === 'scheme') {
            href = path;
        }
        else {
            href = 'oia-pan-ssl.xunlei.com';
            const query = encodeURIComponent(path);
            href = `https://${href}/?query=${query}` + (from && `&ct=${from}`);
        }
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
/**
 * @description 在inline web worker中运行函数
 * @param {Function} func - 函数
 * @param {any[]} message - 函数参数
 * @returns {Promise} - 返回Promise对象执行结果
 */
export function promiseWorkerFun(func, ...message) {
    const delegate = () => {
        onmessage = ({ data: { func, message } }) => {
            const wrapper = (fn) => Function('"use strict"; return (' + fn.toString() + ')')();
            const result = wrapper(func)(...message);
            postMessage(result);
        };
    };
    const functionBody = delegate
        .toString()
        .replace(/^[^{]*{\s*/, '')
        .replace(/\s*}[^}]*$/, '');
    return new Promise((resolve, reject) => {
        const worker = new Worker(URL.createObjectURL(new Blob([functionBody], { type: 'text/javascript' })));
        worker.onmessage = ({ data }) => {
            resolve(data);
            worker.terminate();
        };
        worker.onerror = worker.onmessageerror = reject;
        worker.postMessage({ func: func.toString(), message });
        return worker;
    });
}
export function callAndroid(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { target, action, params, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        let queryParams = '';
        if (params) {
            queryParams = Object.entries(params)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
        }
        const href = `xunleiapp://xunlei.com/${target}/${action}?${queryParams}`;
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
export function parseSearch(url = location.search) {
    const theRequest = new Object();
    if (url.indexOf("?") != -1) {
        const str = url.substring(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}
//# sourceMappingURL=data:application/json;base64,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